import { jsPDF } from "jspdf";

export default function genPDFEPSONLX({ datosfactura, detallefactura, isCredito, TextoNumber, sum1, sum2, impx, impy }) {
  const doc = new jsPDF({
    unit: 'mm', // Cambiado a milímetros
    orientation: 'landscape',
    format: [310,210] // A4 en mm: 297 mm x 210 mm
  });

  // Manejo de valores nulos
  if (datosfactura.direccion == null) {
    datosfactura.direccion = "";
  }
  if (datosfactura.telefono == null) {
    datosfactura.telefono = "";
  }
  datosfactura.iva5 = datosfactura.iva5 ? datosfactura.iva5 : datosfactura.gravado05;
  datosfactura.iva10 = datosfactura.iva10 ? datosfactura.iva10 : datosfactura.gravado10;
  datosfactura.totalmonto = datosfactura.totalmonto ? datosfactura.totalmonto : datosfactura.totalFactura;
  datosfactura.ivatotal = datosfactura.ivatotal ? datosfactura.ivatotal : Number(datosfactura.gravado05 + datosfactura.gravado10);
  datosfactura.Subtotal5 = datosfactura.Subtotal5 ? datosfactura.Subtotal5 : sum1;
  datosfactura.Subtotal10 = datosfactura.Subtotal10 ? datosfactura.Subtotal10 : sum2;
  datosfactura.fechafactura = datosfactura.fechafactura ? datosfactura.fechafactura : new Date().toLocaleDateString();

  const writePage = (offsetX = 0, offsetY = 0) => {
    // Separación entre ítems del listado (20 px / 2.834645 ≈ 7.05 mm)
    let gapRow = 12;

    // Cambiar según booleano para saber si es Contado o Crédito
    let isContado = !isCredito; // Corregido: asumiendo que isCredito=true significa Crédito
    let casillaX = offsetX + (123.5) + (isContado ? 12 : 23); // 265 px ≈ 93.53 mm, 28 px ≈ 9.88 mm

    doc.setFont(undefined, "normal")
    doc.setFontSize(7.5);

    // Casilla Contado/Crédito
    doc.text("X", casillaX, offsetY + (34)); // 106 px ≈ 37.40 mm

    // Fecha de emisión
    doc.text(datosfactura.fechafactura, offsetX + (35), offsetY + (35)); // 56 px ≈ 19.76 mm, 107 px ≈ 37.75 mm

    // Razón social
    doc.text(datosfactura.razonsocial, offsetX + (40), offsetY + (38.5)); // 67 px ≈ 23.64 mm, 116 px ≈ 40.92 mm

    // RUC / CI
    doc.text(datosfactura.ruc, offsetX + (33), offsetY + (42.5)); // 56 px ≈ 19.76 mm, 126 px ≈ 44.45 mm

    // Dirección (corregido)
    doc.text(datosfactura.direccion, offsetX + (70), offsetY + (42.5)); // 138 px ≈ 48.69 mm, 126 px ≈ 44.45 mm

    // Teléfono (corregido)
    doc.text(datosfactura.telefono, offsetX + (128), offsetY + (42.5)); // 263 px ≈ 92.82 mm, 126 px ≈ 44.45 mm

    // Bucle para iterar lista de productos
    for (const [index, obj] of detallefactura.entries()) {
      addRow(obj, offsetX + (3), offsetY + (53.5) + (index * gapRow)); // 6 px ≈ 2.12 mm, 146 px ≈ 51.51 mm
    }

    // Subtotal 5%
    doc.text(String(Math.round(datosfactura.Subtotal5)), offsetX + (120), offsetY + (193+5.5)); // 230 px ≈ 81.14 mm, 450 px ≈ 158.76 mm

    // Subtotal 10%
    doc.text(String(Math.round(datosfactura.Subtotal10)), offsetX + (132), offsetY + (193+5.5)); // 270 px ≈ 95.28 mm, 450 px ≈ 158.76 mm

    // Total a pagar en letras
    doc.text(TextoNumber, offsetX + (42), offsetY + (196+5), { maxWidth: 180 / 2.834645 }); // 68 px ≈ 23.99 mm, 420 px ≈ 148.22 mm, 180 px ≈ 63.50 mm

    // Total a pagar en números
    doc.text(String(datosfactura.totalmonto), offsetX + (132), offsetY + (198+5)); // 269 px ≈ 94.93 mm, 420 px ≈ 148.22 mm

    // Total IVA 5%
    doc.text(String(datosfactura.iva5), offsetX + (54.5), offsetY + (203.5+5)); // 100 px ≈ 35.27 mm, 430 px ≈ 151.75 mm

    // Total IVA 10%
    doc.text(String(datosfactura.iva10), offsetX + (83.5), offsetY + (203.5+5)); // 165 px ≈ 58.21 mm, 430 px ≈ 151.75 mm

    // Total IVA
    doc.text(String(datosfactura.ivatotal), offsetX + (118.5), offsetY + (203.5+5)); // 240 px ≈ 84.67 mm, 430 px ≈ 151.75 mm
  };

  // Función que añade filas a la lista del PDF
  const addRow = (data, x = 0, y) => {
    doc.text(String(data.cantidad), x + (13.5), y); // 20 px ≈ 7.05 mm
    doc.text(String(data.artcod), x + (23), y); // 40 px ≈ 14.11 mm
    doc.text(data.producto, x + (35), y, { maxWidth: 70 / 2.834645 }); // 66 px ≈ 23.29 mm, 70 px ≈ 24.70 mm
    doc.text(String(data.precio), x + 83, y); // 170 px ≈ 59.97 mm
    doc.text(String(data.exenta), x + 98, y); // 203 px ≈ 71.62 mm
    doc.text(String(data.cinco), x + 113, y); // 233 px ≈ 82.20 mm
    doc.text(String(data.diez), x + 131, y); // 269 px ≈ 94.93 mm
  };

  // Llamadas a writePage con coordenadas en mm
  writePage(impx+4, impy-0.5); // Convertir impx, impy a mm
  writePage(impx +158.5, impy-0.5); // 336 px ≈ 118.51 mm, -7 px ≈ -2.47 mm

  doc.autoPrint();
  doc.output('dataurlnewwindow');
}